export default __webpack_public_path__ + "static/SaudiArabia-9ea37936ead643b33888bdcbad3f5a3d.jpg";